import * as React from 'react';

import { get as userGet } from 'js/lib/user';

import { useConsumerMyPageHeader } from 'bundles/composable-page-header-consumer/contexts/ConsumerMyPageHeaderContext';
import DegreeLearnerOnConsumerDesktopMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/desktop/DegreeLearnerOnConsumerDesktopMainNav';
import EnterpriseLearnerOnConsumerDesktopMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/desktop/EnterpriseLearnerOnConsumerDesktopMainNav';
import LoggedInConsumerNoSubNavDesktopMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/desktop/LoggedInConsumerNoSubNavDesktopMainNav';
import LoggedOutConsumerDesktopMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/desktop/LoggedOutConsumerDesktopMainNav';

const AccountPageDesktopMainNav = () => {
  const { chosenEnterpriseProgram, chosenDegree } = useConsumerMyPageHeader();
  const user = userGet();

  const getDesktopNav = () => {
    if (user?.id && !!chosenEnterpriseProgram) {
      return EnterpriseLearnerOnConsumerDesktopMainNav;
    } else if (user?.id && !!chosenDegree) {
      return DegreeLearnerOnConsumerDesktopMainNav;
    } else if (user?.id) {
      return LoggedInConsumerNoSubNavDesktopMainNav;
    } else {
      return LoggedOutConsumerDesktopMainNav;
    }
  };

  const DesktopNavComponent = getDesktopNav();

  return <DesktopNavComponent />;
};

export default AccountPageDesktopMainNav;
